<template>
  <div class="tbp">
    <div class="base">
      <!-- <div class="row" v-if="titleType != ''">
        <div class="title">类型</div>
        <div class="srk">
          <template v-for="item in radioValue">
          <i><input type="radio"
          name="nameType"
          v-model="titleType"
          class="check_box tui-checkbox"
          @change="changetitleType"
          :value="item.type"><span>{{item.name}}</span></i>
          </template>
        </div>
      </div> -->
      <div class="row">
        <div class="title"><span>*</span>发票抬头</div>
        <div class="srk">
          <input type="text" v-model="form.companyName" placeholder="请输入抬头名称" maxlength="50">
        </div>
      </div>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">纳税人识别号</div>
          <div class="srk">
            <input type="text" v-model="form.taxId" placeholder="请输入纳税人识别号" maxlength="22">
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">注册地址</div>
          <div class="srk">
            <input type="text" v-model="form.address" placeholder="请输入注册地址" maxlength="64">
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">注册电话</div>
          <div class="srk">
            <input type="text" v-model="form.phone" placeholder="请输入注册电话" maxlength="50">
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">开户银行</div>
          <div class="srk">
            <input type="text" v-model="form.accountName" placeholder="请输入开户银行" maxlength="50">
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">银行账号</div>
          <div class="srk">
            <input type="text" v-model="form.accountNo" placeholder="请输入银行账号" maxlength="50">
          </div>
        </div>
      </template>

      <div class="row last-line">
        <div class="title">是否设为默认</div>
        <div class="srk">
          <switchBtn v-model="form.isDefault"  @switch="onChange" small></switchBtn>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div :class="[canSubmit ? 'continue' : 'uncontinue']" @click="handleSave">保存</div>
    </div>
  </div>
</template>

<script>
import { createInvoiceTitle,getInvoiceTitleDetail,updateInvoiceTitle } from '@/service/invoiceTitle/api.js';
import switchBtn from "@/components/invoiceTitle/add/switch";
export default {
  components: {
    switchBtn
  },
  data() {
    return{
      radioValue : [
        {
          type: 'company',
          name: '企业单位'
        },
        // {
        //   type: 'person',
        //   name: '个人/非企业单位'
        // }
      ],
      titleType: '',
      form: {
        companyName:'',
        taxId: '',
        address: '',
        phone: '',
        accountName: '',
        accountNo: '',
        isDefault: 0
      },
      state: true,
      invoiceId: ''
    }
  },
  created(){
    this.invoiceId = this.$route.query.id
    if(this.invoiceId) {
      window.document.title = '编辑发票抬头'
      this.getDetal(this.invoiceId)
    }else{
       window.document.title = '添加发票抬头'
       this.titleType = 'company'
       this.form.isDefault = 1
    }
  },
  computed: {
    canSubmit: function() {
      if(this.titleType == 'company' && this.form.companyName != ''){
        return true
      } else if(this.titleType == 'person' && this.form.companyName != ''){
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async getDetal(id){
      const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      const parameter = {
          userId: userInfo.userId,
          invoiceId: id
      };
      const { data } = await getInvoiceTitleDetail.call(this, parameter);
      console.log(data)
      this.$nextTick(()=>{
        this.titleType = 'company'
        this.form.companyName = data.companyName
        this.form.taxId = data.taxId
        this.form.isDefault = data.isDefault
        this.form.address = data.address
        this.form.phone = data.phone
        this.form.accountName = data.accountName
        this.form.accountNo = data.accountNo
        // if(!this.form.taxId){
        //   this.titleType = 'person'
        //   this.form.companyName = '个人'
        // }else{
        //   this.titleType = 'company'
        // }
        // if(this.titleType == 'person'){
        //   this.form.companyName = '个人'
        // }
        if(this.titleType == 'person'){
          this.form.companyName = '个人'
        }
        this.radioValue = this.radioValue.filter((item)=>{
          return item.type == this.titleType
        })
      })
    },
    changetitleType() {
      if(this.titleType == 'person'){
         this.form = {
          companyName:'个人',
          taxId: '',
          isDefault: 1
        }
      }else{
        this.form = {
          companyName:'',
          taxId: '',
          isDefault: 1
        }
      }
    },
    onChange (val) {
      this.form.isDefault = val.status
    },
    checkParams () {
      if(!this.state){
        this.$toast(`请勿重复点击`)
        return false;
      }
      if(this.form.companyName != ''){
        // 公司正则
        const regu =/^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/;
        const companyCheck = new RegExp(regu);
        if (!companyCheck.test(this.form.companyName)) {
          this.$toast(`请填写正确公司名称`);
          return false;
        }
      }
      if(this.titleType == 'company' && this.form.taxId != '') {
        // 税号正则
        const regu =/^$|^[a-zA-Z0-9]{15}$|^[a-zA-Z0-9]{17}$|^[a-zA-Z0-9]{18}$|^[a-zA-Z0-9]{20}$/;
        const taxIdCheck = new RegExp(regu);
        if (!taxIdCheck.test(this.form.taxId)) {
          this.$toast(`请填写正确税号`);
          return false;
        }
      }


    // 注册地址
    if (this.form.address != '') {
      const addressregu = /^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/
      const addressCheck = new RegExp(addressregu)
      if (!addressCheck.test(this.form.address)) {
        this.$toast(`请填写正确注册地址`);
        return false;
      }
    }

  console.log(this.form.phone)
    // 手机号校验
     if (this.form.phone != '') {
      const phoneregu = /^((0\d{2,3}-\d{7,8})|(1[3-9][0-9]{9}))$/
      const phoneCheck = new RegExp(phoneregu)
      if (!phoneCheck.test(this.form.phone)) {
        this.$toast(`注册电话格式不正确`);
        return false;
      }
    }


    // 开户银行
    if (this.form.accountName != '') {
      const accountNameregu = /^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/
      const accountNameCheck = new RegExp(accountNameregu)
     if (!accountNameCheck.test(this.form.accountName)) {
        this.$toast(`开户银行格式不正确`);
        return false;
      }
    }
    

    // 银行卡号校验
 
    if (this.form.accountNo != '') {

      const accountNoregu = /^[0-9]{1,30}$/
      const accountNoCheck = new RegExp(accountNoregu)
      if (!accountNoCheck.test(this.form.accountNo)) {
        this.$toast(`银行账号格式不正确`);
        return false;
      }
    }

      if(this.titleType == 'person') {
        Object.keys(this.form).forEach(item => {
          if (this.form[item] === '') delete this.form[item]
        })
      }
      return true
    },
    async handleSave () {
      if(this.titleType === 'person' && this.form.companyName == '') return;
      if(this.titleType === 'company' && (this.form.companyName == '')) return
      const flag = this.checkParams()
      if(!flag) return
      this.form.userId = JSON.parse(window.localStorage.getItem('userInfo')).userId
      this.form.type = this.titleType
      this.state = false
      if(!this.invoiceId){
        try {
          const res = await createInvoiceTitle.call(this, this.form);
          if(res.errorMessage == '') {
             this.state = true
            this.$toast(`创建成功`)
            this.$router.push(`/invoiceTitleList`);
            return
          }else{
            this.$toast(res.errorMessage)
            return;
          }
          console.log(res)
        } catch (error) {
          this.$toast(`创建失败`)
          return;
        }
        // this.state = true
        // this.$toast(`创建成功`)
      }else{
        this.form.invoiceId = this.invoiceId
        try {
          const res = await updateInvoiceTitle.call(this, this.form);
          if(res.errorMessage == '') { 
            this.state = true
            this.$toast(`编辑成功`)
            this.$router.push(`/invoiceTitleList`);
            return
          }else{
            this.$toast(res.errorMessage)
            return;
          }
        } catch (error) {
          this.$toast(`编辑失败`)
          return;
        }
        // this.state = true
        // this.$toast(`编辑成功`)
      }
      // this.$router.push(`/invoiceTitleList`);
    }
  }
}
</script>

<style scoped lang='less'>
.tbp {
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.base{
  background: #FFFFFF;
  padding: .266667rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;
}
.row {
  display: flex;
  justify-content: space-between;
  padding: .4rem 0;
  color:#000;
  font-size: .4rem;
  flex: 1;
  .title{
    width: 3.866667rem;
    line-height: .56rem;
    span{
      font-size: .373333rem;
      color: red;
    }
  }
  .srk {
    width: 100%;
    display: flex;
    span{
      color: #999999;
      display: inline-block;
      padding: 0 .133333rem;
      margin-top: .04rem;
    }
    i{
      display: block;
      // padding: 0 0 0 0;
    }
    input[type="text"] {
      display:block;
      width: 100%;
      line-height: .56rem;
    }
    .other-btn{
      display: inline-block;
      margin-top: .066667rem;
      // width: 1.333333rem;
      width: 1.333333rem;
      font-size: .32rem;
      text-align: center;
      padding: .133333rem;
      background: #9D6C29;
      color: #fff;
      border-radius: .133333rem;
    }
  }
}
.last-line{
  padding-bottom: 8rem;
}
.bottom{
  height: 1.6rem + .346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #f2f2f2;
  .continue{
    position: fixed;
    margin: auto;
    width: 98%;
    bottom: .266667rem;
    left: 0;
    right: 0;
    background: #9D6C29;
    line-height: 1.2rem;
    border-radius: 1.333333rem;
    text-align: center;
    color: #FFFFFF;
    font-size: .48rem;
  }
  .uncontinue{
    position: fixed;
    margin: auto;
    width: 98%;
    bottom: .266667rem;
    left: 0;
    right: 0;
    background: #999999;
    line-height: 1.2rem;
    border-radius: 1.333333rem;
    text-align: center;
    color: #FFFFFF;
    font-size: .48rem;
  }
}
.tui-checkbox {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}
.tui-checkbox:checked {
  background: #DB4239;
  border: solid 1px #DB4239;
}
.tui-checkbox:checked::after {
  content: '';
  top: 0.1rem;
  left: 0.09rem;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 0.12rem;
  width: 0.25rem;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>
